module.exports = __webpack_public_path__ + "img/jointo-bhc.cc2324fa.jpg";